import PonchoIcon from "./PonchoIcon";

export default function AguaIcon({ ...props }) {
  return <PonchoIcon name="agua" {...props} />;
}
